export type LiveDataEventLog = {
  ConnectionType: 'CLGNUser',
  AuthToken: string,
  UserID: string,
  UserEmail: string,
  EventAction: 'CLGNConnect' | 'CLGNStatusCheck'
}

/**
 * Defines Live State interface
 */
export type LiveDataProjectItem = { // project
  geo:Record<string, number>, // country => amount
  platforms: Record<string, number>, // platform => amount
  locations: Record<string, number>, // location => amount
  users: [], // array of userIDs
  anomalies: {
      ensure: number,
      crashes: number
  },
  totalUsers: number
};

export type LiveDataProject = {
  client: LiveDataProjectItem,
  editor: LiveDataProjectItem,
  server: LiveDataProjectItem
}
  
export interface LiveDataState {
  socket:WebSocket,
  projectsData: Record<string,LiveDataProject>
}
    
/**
  * Defines LiveData actions names
  */
export const LIVEDATA_CONNECT = 'LIVEDATA_CONNECT'
export const LIVEDATA_DISCONNECT = 'LIVEDATA_DISCONNECT'
export const LIVEDATA_UPDATE = 'LIVEDATA_UPDATE'
    
/**
  * Defines LiveData actions interfaces
  */
interface LiveDataConnectAction {
  type: typeof LIVEDATA_CONNECT;
  payload: {
    socket: WebSocket,
    projectsData: Record<string,LiveDataProject>
  }
}

interface LiveDataDisconnectAction {
  type: typeof LIVEDATA_DISCONNECT;
}

interface LiveDataUpdateAction {
  type: typeof LIVEDATA_UPDATE;
  payload: {
    socket: WebSocket,
    projectsData: Record<string,LiveDataProject>
  }
}
    
/**
  * Defines all suported actions for LiveData
  */
 
export type LiveDataActionTypes =
  LiveDataConnectAction |
  LiveDataDisconnectAction |
  LiveDataUpdateAction;
    
/**
  * Defines LiveDataActionsInterface
  */
 
export interface LiveDataActionsInterface {
  liveDataConnect: () => Promise<void>;
  liveDataDisconnect: () => Promise<void>;
  liveDataUpdate: () => Promise<void>;
  liveDataIsConnected: () => boolean;
}
    